import * as angular from "angular";
import {IController} from "angular";

export class selfPickupActionMenuCtrl implements IController {

  status: any;
  onAction: Function;

  private actionsByStatusMap: any;
  private actions: any;
  private printingEnabled: any;

  /* @ngInject */
  constructor(private selfPickupsConstants) {
  }

  $onInit() {
    this.actionsByStatusMap = {};
    this.actions = [];
    this.printingEnabled = false;

    this.actionsByStatusMap = this.selfPickupsConstants.selfPickupActionsByStatusMap;
    this.actions = this.actionsByStatusMap[this.status];
  };

  $onChanges(changes) {
    if (changes.status && !changes.status.isFirstChange()) {
      this.actions = this.actionsByStatusMap[this.status];
    }
  };

  onActionSelect(actionName) {
    this.onAction({action: actionName});
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupActionMenu', {
    bindings: {
      status: '<',
      onAction: '&'
    },
    template: require('./self-pickup-action-menu.html').default,
    controller: selfPickupActionMenuCtrl
  });
